import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-panel-wrapper',
    template: `
  <mat-expansion-panel class="formly-panel" [expanded]="to['expanded']">
    <mat-expansion-panel-header class="formly-panel-header">
      <mat-panel-title class="formly-panel-title">
        <!-- <mat-icon class="formly-panel-icon">{{ to['icon'] }}</mat-icon> -->
        <span>{{ to['label'] }}</span>
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="formly-panel-content">
      <ng-container #fieldComponent></ng-container>
    </div>
  </mat-expansion-panel>
  `,
    styles: [`
    .formly-panel {
      font-family:'poppins';
      border-radius: 10px;
      margin-bottom: 5px;
      box-shadow: rgba(0, 0, 0, 0.08) 0px 2px 8px;
      transition: all 0.25s ease;
      background: #fff;
      border: 1px solid rgba(0, 0, 0, 0.08);
    }

    .formly-panel:hover {
      box-shadow: rgba(0, 0, 0, 0.14) 0px 4px 12px;
    }

    .formly-panel-header {
      height:40px;
      // background: #fafafa;
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
      padding: 6px 12px;
      border-radius: 8px 8px 0 0;
    }

    .formly-panel-title {
      font-family:'poppins';
      display: flex;
      align-items: normal;
      gap: 5px;
      font-weight: 600;
      font-size: 12px;
      color: #101D42;
    }

    .formly-panel-icon {
      font-size: 18px;
      color: #1363DF;
    }

    .formly-panel-content {
      padding: 8px 0px 0px 0px;
    }

    .formly-panel-content .mat-mdc-form-field,
    .formly-panel-content formly-field {
      width: 100%;
      margin-bottom: 12px;
    }
  `],
    standalone: false
})
export class PanelWrapperComponent extends FieldWrapper {
  constructor() { super(); }
}
